import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './Overdue.css';

const Overdue = ({ count = 0 }) => {
    return (
        <div className="overdue-card">
            <div className="overdue-header">
                <span className="overdue-title">Overdue</span>
                <FontAwesomeIcon icon={faExclamationTriangle} className="overdue-icon" />
            </div>
            <span className="overdue-count">{count}</span>
        </div>
    );
};

export default Overdue;

